module.exports = __webpack_public_path__ + "img/fruit-mandarins-190x100.4daa2ce9.jpg";